var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1047.8 450.3",
    style: {
      enableBackground: "new 0 0 1047.8 450.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#CCCCCC;}\n\t.st2{fill:#C9C9C9;}\n\t.st3{fill:#E6E6E6;}\n\t.st4{fill:#D8D8D8;}\n\t.st5{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.3,395.5c0-9.5,7.7-17.2,17.2-17.2s17.1,7.7,17.2,17.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.5,395.5c-0.3,0-0.5-0.2-0.5-0.5v-9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5l0,0v9 C46.9,395.3,46.7,395.5,46.5,395.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.5,392.4c-0.1,0-0.2,0-0.3-0.1l-5.6-4.8c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1l0,0l5.6,4.8 c0.2,0.2,0.2,0.5,0,0.7C46.7,392.3,46.6,392.4,46.5,392.4L46.5,392.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.2,395.5c0-9.5,7.7-17.2,17.2-17.1c9.5,0,17.1,7.7,17.1,17.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.4,395.5c-0.3,0-0.5-0.2-0.5-0.5v-9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v9 C99.8,395.3,99.6,395.5,99.4,395.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.4,392.4c-0.1,0-0.2,0-0.3-0.1l-5.6-4.8c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1l0,0l5.6,4.8 c0.2,0.2,0.2,0.5,0,0.7C99.6,392.3,99.5,392.4,99.4,392.4L99.4,392.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M521.8,367.7c0.6,0,1-0.4,1-1s-0.4-1-1-1h-9.5v-4h9.5c0.6,0,1-0.4,1-1s-0.4-1-1-1h-81c-0.6,0-1,0.4-1,1 s0.4,1,1,1h9.5v4h-9.5c-0.6,0-1,0.4-1,1s0.4,1,1,1h9.5v4h-9.5c-0.6,0-1,0.4-1,1s0.4,1,1,1h9.5v4h-8.5c-1.1,0-2,0.9-2,2s0.9,2,2,2 h8.1c-0.1,0.2-0.1,0.3-0.1,0.5v14c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5v-14c0-0.2,0-0.3-0.1-0.5h57.2c-0.1,0.2-0.1,0.3-0.1,0.5v14 c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5v-14c0-0.2,0-0.3-0.1-0.5h8.1c1.1,0,2-0.9,2-2s-0.9-2-2-2h-8.5v-4h9.5c0.6,0,1-0.4,1-1 s-0.4-1-1-1h-9.5v-4H521.8z M452.3,361.7h58v4h-58V361.7z M510.3,377.7h-58v-4h58V377.7z M510.3,371.7h-58v-4h58V371.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.8,325.7c0-17.7-14.3-59.6-32-59.6s-32,41.9-32,59.6s14.3,32,32,32S216.8,343.4,216.8,325.7L216.8,325.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8,325.7c0-17.7-14.3-59.6-32-59.6s-32,41.9-32,59.6s14.3,32,32,32S208.8,343.4,208.8,325.7L208.8,325.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.8,397.3c-0.6,0-1-0.4-1-1v-89.1c0-0.6,0.4-1,1-1s1,0.4,1,1v89.1C178.8,396.8,178.3,397.3,177.8,397.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.8,321.7c-0.6,0-1-0.4-1-1c0-0.3,0.1-0.5,0.3-0.7l13.1-13.1c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-13.1,13.1 C178.3,321.6,178.1,321.7,177.8,321.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M545.8,397.3c-0.6,0-1-0.4-1-1v-89.1c0-0.6,0.4-1,1-1s1,0.4,1,1v89.1C546.8,396.8,546.3,397.3,545.8,397.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M652.8,325.7c0-17.7-14.3-59.6-32-59.6s-32,41.9-32,59.6s14.3,32,32,32S652.8,343.4,652.8,325.7L652.8,325.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M644.8,325.7c0-17.7-14.3-59.6-32-59.6s-32,41.9-32,59.6s14.3,32,32,32S644.8,343.4,644.8,325.7L644.8,325.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.8,397.3c-0.6,0-1-0.4-1-1v-89.1c0-0.6,0.4-1,1-1s1,0.4,1,1v89.1C614.8,396.8,614.3,397.3,613.8,397.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.8,321.7c-0.6,0-1-0.4-1-1c0-0.3,0.1-0.5,0.3-0.7l13.1-13.1c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-13.1,13.1 C614.3,321.6,614.1,321.7,613.8,321.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M283.8,51.8h-16c-2.5,0-4.5-2-4.5-4.5v-37c0-2.5,2-4.5,4.5-4.5h16c2.5,0,4.5,2,4.5,4.5v37 C288.3,49.8,286.3,51.8,283.8,51.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M346.8,396.8h-82c-4.7,0-8.5-3.8-8.5-8.5v-331c0-4.7,3.8-8.5,8.5-8.5h82c4.7,0,8.5,3.8,8.5,8.5v331 C355.3,393,351.5,396.8,346.8,396.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.8,396.8h-82c-4.7,0-8.5-3.8-8.5-8.5v-331c0-4.7,3.8-8.5,8.5-8.5h82c4.7,0,8.5,3.8,8.5,8.5v331 C306.3,393,302.5,396.8,297.8,396.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.8,51.8h-16c-2.5,0-4.5-2-4.5-4.5v-37c0-2.5,2-4.5,4.5-4.5h16c2.5,0,4.5,2,4.5,4.5v37 C273.3,49.8,271.3,51.8,268.8,51.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M247.8,123.8h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C250.3,122.7,249.2,123.8,247.8,123.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M284.8,123.8h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C287.3,122.7,286.2,123.8,284.8,123.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M247.8,176.8h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C250.3,175.7,249.2,176.8,247.8,176.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M284.8,176.8h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C287.3,175.7,286.2,176.8,284.8,176.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M247.8,229.8h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C250.3,228.7,249.2,229.8,247.8,229.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M284.8,229.8h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C287.3,228.7,286.2,229.8,284.8,229.8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M247.8,282.8h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C250.3,281.7,249.2,282.8,247.8,282.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M284.8,282.8h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C287.3,281.7,286.2,282.8,284.8,282.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M247.8,335.8h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C250.3,334.7,249.2,335.8,247.8,335.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M284.8,335.8h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C287.3,334.7,286.2,335.8,284.8,335.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M696.8,226.8h-16c-2.5,0-4.5-2-4.5-4.5v-21c0-2.5,2-4.5,4.5-4.5h16c2.5,0,4.5,2,4.5,4.5v21 C701.3,224.8,699.3,226.8,696.8,226.8z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M831.8,397.8h-82c-4.7,0-8.5-3.8-8.5-8.5v-159c0-4.7,3.8-8.5,8.5-8.5h82c4.7,0,8.5,3.8,8.5,8.5v159 C840.3,394,836.5,397.8,831.8,397.8z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M782.8,397.8h-142c-4.7,0-8.5-3.8-8.5-8.5v-159c0-4.7,3.8-8.5,8.5-8.5h142c4.7,0,8.5,3.8,8.5,8.5v159 C791.3,394,787.5,397.8,782.8,397.8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M681.8,226.8h-16c-2.5,0-4.5-2-4.5-4.5v-21c0-2.5,2-4.5,4.5-4.5h16c2.5,0,4.5,2,4.5,4.5v21 C686.3,224.8,684.3,226.8,681.8,226.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M702.8,300.3h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C705.3,299.2,704.2,300.3,702.8,300.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M739.8,300.3h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C742.3,299.2,741.2,300.3,739.8,300.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M702.8,353.3h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C705.3,352.2,704.2,353.3,702.8,353.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M739.8,353.3h-19c-1.4,0-2.5-1.1-2.5-2.5v-29c0-1.4,1.1-2.5,2.5-2.5h19c1.4,0,2.5,1.1,2.5,2.5v29 C742.3,352.2,741.2,353.3,739.8,353.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1046.8,398.3H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h1045.8c0.6,0,1,0.4,1,1S1047.3,398.3,1046.8,398.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M415.8,325.7c0-17.7-14.3-59.6-32-59.6s-32,41.9-32,59.6s14.3,32,32,32S415.8,343.4,415.8,325.7L415.8,325.7z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M407.8,325.7c0-17.7-14.3-59.6-32-59.6s-32,41.9-32,59.6s14.3,32,32,32S407.8,343.4,407.8,325.7L407.8,325.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.8,397.3c-0.6,0-1-0.4-1-1v-89.1c0-0.6,0.4-1,1-1s1,0.4,1,1v89.1C377.8,396.8,377.3,397.3,376.8,397.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.8,321.7c-0.6,0-1-0.4-1-1c0-0.3,0.1-0.5,0.3-0.7l13.1-13.1c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-13.1,13.1 C377.3,321.6,377.1,321.7,376.8,321.7z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M926.8,325.7c0-17.7-14.3-59.6-32-59.6s-32,41.9-32,59.6s14.3,32,32,32S926.8,343.4,926.8,325.7L926.8,325.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M918.8,325.7c0-17.7-14.3-59.6-32-59.6s-32,41.9-32,59.6s14.3,32,32,32S918.8,343.4,918.8,325.7L918.8,325.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M887.8,397.3c-0.6,0-1-0.4-1-1v-89.1c0-0.6,0.4-1,1-1s1,0.4,1,1v89.1C888.8,396.8,888.3,397.3,887.8,397.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M887.8,321.7c-0.6,0-1-0.4-1-1c0-0.3,0.1-0.5,0.3-0.7l13.1-13.1c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-13.1,13.1 C888.3,321.6,888.1,321.7,887.8,321.7z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M556.8,336.8h-22c-1.4,0-2.5-1.1-2.5-2.5v-22c0-1.4,1.1-2.5,2.5-2.5h22c1.4,0,2.5,1.1,2.5,2.5v22 C559.3,335.7,558.2,336.8,556.8,336.8z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M781.1,339c0-0.2,0.2-0.3,0.3-0.3s0.3,0.2,0.3,0.3c0,0.1-0.1,0.3-0.2,0.3v0.7c0,0.1-0.1,0.1-0.1,0.1l-0.1-0.1 l0,0v-0.7C781.2,339.3,781.1,339.2,781.1,339z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M913.3,395.5c0-9.5,7.7-17.2,17.2-17.1c9.5,0,17.1,7.7,17.1,17.1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M930.5,395.5c-0.3,0-0.5-0.2-0.5-0.5v-9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v9 C930.9,395.3,930.7,395.5,930.5,395.5z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M930.5,392.4c-0.1,0-0.2,0-0.3-0.1l-5.6-4.8c-0.2-0.2-0.2-0.5-0.1-0.7s0.5-0.2,0.7-0.1l0,0l5.6,4.8 c0.2,0.2,0.2,0.5,0,0.7C930.7,392.3,930.6,392.4,930.5,392.4L930.5,392.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M966.2,395.5c0-9.5,7.7-17.2,17.2-17.1c9.5,0,17.1,7.7,17.1,17.1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M983.4,395.5c-0.3,0-0.5-0.2-0.5-0.5l0,0v-9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v9 C983.8,395.3,983.6,395.5,983.4,395.5z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M983.4,392.4c-0.1,0-0.2,0-0.3-0.1l-5.6-4.8c-0.2-0.2-0.2-0.5-0.1-0.7s0.5-0.2,0.7-0.1l0,0l5.6,4.8 c0.2,0.2,0.2,0.5,0,0.7C983.6,392.3,983.5,392.4,983.4,392.4L983.4,392.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.43f9fa3e39a9920ea26ca682fd5ea203.svg";
export { ForwardRef as ReactComponent };